
function replaceImageInUrl(newUrl, srcset) {
  let newSrcset = [];
  const srcsets = srcset.split(',');
  srcsets.forEach((src) => {
    const query = src.substring(src.indexOf('?'), src.length)
    newSrcset.push(`${newUrl}${query}`)
  })
  return newSrcset.join(", ")
}

window.onProductThumbnailClick = function (thumbnail) {
  const heroImgWrapper = document.getElementById('product-image');
  const thumbnails = document.getElementById('product-thumbnails');
  const newImgUrl = thumbnail.dataset.imageUrl;

  if (heroImgWrapper && thumbnails && newImgUrl) {
    const picture = heroImgWrapper.getElementsByTagName('picture')[0]
    const sources = picture.getElementsByTagName('source');
    const img = picture.getElementsByTagName('img')[0];

    [...sources].forEach((source) => {
      const newSrcset = replaceImageInUrl(newImgUrl, source.srcset);
      const newImgsrc = replaceImageInUrl(newImgUrl, img.src)
      source.srcset = newSrcset;
      img.src = newImgsrc;
    });

    [...thumbnails.children].forEach((thumb) => {
      thumb.classList.remove('selected')
    })

    thumbnail.classList.add('selected')
  }
}